import { Show, SimpleShowLayout } from "react-admin";

import BackButtonToolbar from "features/BackButtonToolbar";
import SecuredComponent from "server/security/SecuredComponent";

import { outgoingStudentsPermissions } from "../permissions";
import AbsenceDatesDialog from "./components/AbsenceDatesDialog";
import BusinessTripOrderDialog from "./components/BusinessTripOrderDialog";
import BusinessTripReportButton from "./components/BusinessTripReportButton";
import FundingContractDialog from "./components/FundingContractDialog";
import CompleteMobilityDialog from "./components/CompleteMobilityDialog";
import ReturnApplicationForCorrectionDialog from "./components/ReturnApplicationForCorrectionDialog";
import DocumentsSection from "./DocumentsSection";
import EducationSection from "./EducationSection";
import FundingSection from "./FundingSection";
import InterviewSection from "./InterviewSection";
import MobilityDetailsSection from "./MobilityDetailsSection";
import NotesSection from "./NotesSection";
import PersonalDataSection from "./PersonalDataSection";
import PreferencesSection from "./PreferencesSection";
import StatusHeader from "./StatusHeader";
import UniversitiesSection from "./UniversitiesSection";

const ShowOutgoingApplicationsStudent = () => (
  <Show
    title="Детайли на заминаващ за обучение"
    actions={
      <BackButtonToolbar
        additionalButton={
          <SecuredComponent permission={outgoingStudentsPermissions}>
            <BusinessTripReportButton />
            <BusinessTripOrderDialog />
            <FundingContractDialog />
            <AbsenceDatesDialog />
            <ReturnApplicationForCorrectionDialog />
            <CompleteMobilityDialog />
          </SecuredComponent>
        }
      />
    }
  >
    <SimpleShowLayout>
      <StatusHeader />
      <PersonalDataSection />
      <EducationSection />
      <MobilityDetailsSection />
      <DocumentsSection />
      <NotesSection />
      <UniversitiesSection />
      <PreferencesSection />
      <InterviewSection />
      <FundingSection />
    </SimpleShowLayout>
  </Show>
);

export default ShowOutgoingApplicationsStudent;
